export interface PaginateItem {
  id: string
  height: number
}

// Greedy bin-packing: fill the current page with items in order; when the next
// item would push us past `maxHeight`, start a new page (mirroring react-pdf's
// per-section `wrap={false}` flow). An item taller than `maxHeight` still gets
// its own page rather than being silently dropped.
export const paginateByHeight = (items: PaginateItem[], maxHeight: number): string[][] => {
  const pages: string[][] = []
  let current: string[] = []
  let used = 0

  for (const { id, height } of items) {
    const overflowsCurrent = used + height > maxHeight && current.length > 0
    if (overflowsCurrent) {
      pages.push(current)
      current = [id]
      used = height
    } else {
      current.push(id)
      used += height
    }
  }
  if (current.length > 0) pages.push(current)
  return pages
}
